import React from 'react';
// @ts-ignore
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom';
// @ts-ignore
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Constants from '../../data/Constants';
import Layout from './layout/Layout';
import GipHome from './GipHome/GipHome';
import BpsMainMenu from './BpsMainMenu/BpsMainMenu';
import BpsEconomicRegions from './BpsEconomicRegions/BpsEconomicRegions';
import RankingsAndLevels from './RankingsAndLevels/RankingsAndLevels';
import NotFoundComponent from '../../containers/Errors/NotFoundComponent';
import BpsProportions from './BpsProportions/BpsProportions';
import PdfDownload from './PdfDownload/PdfDownload';


// @ts-ignore
const MobileRoutes = withRouter(({ location }) => {
  // Allow /data/* requests to pass through to public content
  if (location.pathname.startsWith('/data/')) {
    return null;
  }

  return (
    <Layout>
      <Switch location={ location }>
        <Route exact path={ Constants.routes.root } component={ GipHome } />
        <Route exact path={ Constants.routes.gip } component={ GipHome } />
        <Route path={ Constants.routes.rankings } component={ RankingsAndLevels } />
        <Route exact path={ Constants.routes.bpsRegions } component={ BpsEconomicRegions } />
        <Route exact path={ Constants.routes.bpsProportion } component={ BpsProportions } />
        <Route path={ Constants.routes.bps } component={ BpsMainMenu } />
        <Route path={ Constants.routes.gipDownload } component={ PdfDownload } />
        <Route path="*" component={ NotFoundComponent } />
      </Switch>
    </Layout>
  );
});

export default MobileRoutes;
